import { render } from "./logo-tri.svg?vue&type=template&id=1dfa2baf"
const script = {}
script.render = render

export default script